<template>
  <div id="login-pec">
    <div class="card card-login">
      <div class="loader"></div>

      <div class="d-flex justify-content-center">
        <div class="card-icon">
          <i class="icofont-user-alt-7"></i>
        </div>
      </div>

      <div id="form">
        <h2 class="card-title text-center mt-1">LOGIN</h2>

        <div v-if="status === 'loading'" class="login-pec-status">
          <b-spinner
            label="Autenticando"
            variant="primary"
            class="login-pec-status__spinner"
          />

          <h5>Autenticando...</h5>

          <p>Aguarde enquanto validamos seu acesso.</p>
        </div>

        <div v-else-if="status === 'error'" class="login-pec-status">
          <div class="login-pec-status__icon login-pec-status__icon--error">
            <i class="icofont-exclamation-circle"></i>
          </div>

          <h5>Acesso negado</h5>

          <p>{{ mensagemErro }}</p>
        </div>

        <div v-else-if="status === 'form'">
          <ValidationObserver ref="observer" class="row">
            <form @submit.prevent="continuar">
              <div class="col-12">
                <validation-provider v-slot="{ errors }" rules="required|cpf">
                  <div class="form-group input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icofont-card"></i>
                      </span>
                    </div>

                    <the-mask
                      v-model="cpf"
                      :mask="['###.###.###-##']"
                      class="form-control"
                      placeholder="CPF"
                      disabled
                    />
                  </div>

                  <div class="error my-2">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div v-if="verificandoUsuario" class="col-12">
                <b-alert show variant="primary">
                  <b-spinner
                    label="Verificando usuário"
                    small
                    variant="primary"
                  />

                  Aguarde! Verificando usuário.
                </b-alert>
              </div>

              <div class="col-12">
                <button
                  type="submit"
                  class="btn float-right mt-0"
                  :disabled="loadingBtn"
                >
                  <span v-if="!loadingBtn"> Continuar </span>

                  <b-spinner v-else label="Verificando" small variant="white" />
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>

        <div
          v-else-if="status === 'escolha-visualizacao'"
          class="escolha-visualizacao"
        >
          <button
            type="button"
            class="btn-visualizacao"
            :disabled="loadingBtn"
            @click="visualizarEmNovaAba"
          >
            <i class="icofont-external-link"></i>

            <span>Ver em outra aba</span>
          </button>

          <button
            type="button"
            class="btn-visualizacao btn-visualizacao--principal"
            :disabled="loadingBtn"
            @click="visualizarNoIframe"
          >
            <i class="icofont-eye-alt"></i>

            <span>Ver aqui mesmo</span>
          </button>
        </div>

        <div v-else-if="status === 'usuario-nao-encontrado'">
          <ValidationObserver ref="observerCadastro" v-slot="{ invalid }">
            <form @submit.prevent="cadastrarUsuarioPec">
              <div class="col-12">
                <b-alert show variant="warning">
                  Preencha os campos abaixos para liberar o acesso ao
                  monitoramento e avaliação pelo eSUS Feedback.
                </b-alert>
              </div>

              <!-- CPF -->
              <div class="col-12">
                <validation-provider
                  v-slot="{ errors }"
                  name="CPF"
                  rules="required|cpf"
                >
                  <label for="">CPF</label>

                  <div class="form-group input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icofont-card"></i>
                      </span>
                    </div>

                    <the-mask
                      v-model="cpf"
                      :mask="['###.###.###-##']"
                      class="form-control"
                      placeholder="CPF"
                      disabled
                    />
                  </div>

                  <div class="error my-2">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <!-- E-mail -->
              <div class="col-12">
                <validation-provider
                  v-slot="{ errors }"
                  name="E-mail"
                  rules="required|email"
                >
                  <label for="">E-mail</label>

                  <div class="form-group input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icofont-envelope"></i>
                      </span>
                    </div>

                    <input
                      v-model.trim="email"
                      name="email"
                      class="form-control"
                      placeholder=""
                      type="email"
                      autocomplete="email"
                    />
                  </div>

                  <div class="error my-2">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <!-- Data de nascimento -->
              <div class="col-12">
                <validation-provider
                  v-slot="{ errors }"
                  name="Data de nascimento"
                  rules="required"
                >
                  <label for="">Data de nascimento</label>

                  <div class="form-group input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icofont-calendar"></i>
                      </span>
                    </div>

                    <input
                      v-model="dataNascimento"
                      name="data_nascimento"
                      class="form-control"
                      type="date"
                      placeholder="DATA DE NASCIMENTO"
                    />
                  </div>

                  <div class="error my-2">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <!-- Termos de uso -->
              <div class="col-12">
                <validation-provider
                  v-slot="{ errors }"
                  name="Termos de uso"
                  :rules="{ required: { allowFalse: false } }"
                >
                  <div class="form-group">
                    <div class="checkbox-termos">
                      <input
                        id="aceitou-termos-pec"
                        v-model="aceitouTermos"
                        type="checkbox"
                      />

                      <label for="aceitou-termos-pec">
                        Li e estou de acordo com os
                      </label>

                      <button
                        type="button"
                        class="btn-termos"
                        @click="showModalTermos = true"
                      >
                        Termos de uso.
                      </button>
                    </div>
                  </div>

                  <div class="error my-2">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <ModalTermos
                v-if="showModalTermos"
                @close-modal-termos="fecharModalTermos"
                @aceitar-termos="aceitarTermos"
              />

              <!-- reCAPTCHA -->
              <div class="col-12">
                <div class="recaptcha-wrapper">
                  <vue-recaptcha
                    ref="recaptcha"
                    sitekey="6Lc2rcMZAAAAAEajREawZOuLW75FAAm8cGWfnFti"
                    @verify="onVerifyRecaptcha"
                    @expired="onExpiredRecaptcha"
                    @error="onErrorRecaptcha"
                  />
                </div>
              </div>

              <div class="col-12 mt-3">
                <button
                  type="submit"
                  class="btn"
                  :disabled="
                    loadingBtn ||
                    invalid ||
                    !aceitouTermos ||
                    !recaptchaValidado
                  "
                >
                  <span v-if="!loadingBtn">Continuar</span>

                  <b-spinner v-else label="..." small variant="white" />
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>

        <div
          v-else-if="status === 'cadastro-realizado'"
          class="login-pec-status"
        >
          <div class="login-pec-status__icon login-pec-status__icon--success">
            <i class="icofont-check-circled"></i>
          </div>

          <h5>Liberação de acesso realizada com sucesso</h5>

          <p>
            Enviamos uma senha temporária para o e-mail informado. Consulte sua
            caixa de entrada e também a pasta de spam.
          </p>

          <p>Para mais informações acesso o e-mail informado anteriormente.</p>

          <button
            type="button"
            class="btn"
            :disabled="loadingBtn"
            @click="continuarAposCadastro"
          >
            <span v-if="!loadingBtn">Continuar</span>

            <b-spinner v-else label="Continuando" small variant="white" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import Municipio from '@/services/Municipio.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
import VueRecaptcha from 'vue-recaptcha'
import ModalTermos from '@/components/ModalTermos'

validations()

export default {
  name: 'LoginPec',

  components: {
    TheMask,
    ValidationObserver,
    ValidationProvider,
    ModalTermos,
    'vue-recaptcha': VueRecaptcha,
  },

  metaInfo: {
    title: 'Login',
    titleTemplate: null,
    meta: [
      {
        charset: 'utf-8',
      },
      {
        name: 'description',
        content:
          'Um painel de gestão para ajudar profissionais de saúde e gestores no atendimento aos requisitos do financiamento federal da APS.',
      },
    ],
  },
  data() {
    return {
      status: 'form',
      mensagemErro: '',
      cpf: '',
      cnes: '',
      identificadorPublico: '',
      pecTimestamp: '',
      pecSign: '',
      loading: false,
      loadingBtn: false,
      verificandoUsuario: false,
      email: '',
      dataNascimento: '',
      aceitouTermos: false,
      recaptchaValidado: false,
      recaptchaToken: '',
      showModalTermos: false,
      tokenCadastro: '',
      tokenAutenticacao: '',
      usuarioAutenticado: null,
      rotaDestino: '',
    }
  },
  computed: {
    /**
     * Indica que o login PEC foi aberto diretamente em uma nova aba.
     *
     * @returns {boolean}
     */
    acessoEmNovaAba() {
      return String(this.$route.query.novaAba || '') === '1'
    },
  },
  async mounted() {
    const estaDentroDoIframe = this.acessoPermitidoPeloPec()

    /*
     * O acesso é permitido quando:
     *
     * 1. A página foi aberta dentro do iframe do PEC; ou
     * 2. Foi aberta pelo botão "Ver em outra aba".
     */
    if (!estaDentroDoIframe && !this.acessoEmNovaAba) {
      this.exibirErro('Esta página deve ser acessada através do e-SUS APS PEC.')

      return
    }
    this.carregarParametrosPec()

    /*
     * Na nova aba, a autenticação é executada automaticamente.
     * O usuário não precisa clicar novamente em "Continuar".
     */
    if (this.acessoEmNovaAba) {
      await this.autenticarViaPec()
    }
  },
  methods: {
    /**
     * Continua utilizando a aplicação dentro do iframe.
     *
     * @returns {Promise<void>}
     */
    async visualizarNoIframe() {
      if (!this.rotaDestino) {
        this.exibirErro('Não foi possível determinar a página de destino.')

        return
      }

      await this.$router.replace(this.rotaDestino)
    },

    /**
     * Abre novamente o login PEC em uma nova aba.
     *
     * A nova aba refaz automaticamente a autenticação e cria sua
     * própria sessão, sem depender do armazenamento criado no iframe.
     *
     * @returns {void}
     */
    visualizarEmNovaAba() {
      const urlLoginPec = this.$router.resolve({
        path: this.$route.path,
        query: {
          documentoProfissional: this.cpf.replace(/\D/g, ''),
          CNES: this.cnes,
          pec_timestamp: this.pecTimestamp,
          pec_sign: this.pecSign,
          novaAba: '1',
        },
      }).href

      window.open(urlLoginPec, '_blank', 'noopener,noreferrer')
    },

    /**
     * Verifica se a página está sendo acessada dentro de um iframe.
     *
     * @returns {boolean}
     */
    acessoPermitidoPeloPec() {
      return window.self !== window.top
    },

    /**
     * Valida o formulário e inicia a autenticação pelo PEC.
     *
     * @returns {Promise<void>}
     */
    async continuar() {
      const formularioValido = await this.$refs.observer.validate()

      if (!formularioValido) {
        return
      }

      await this.autenticarViaPec()
    },

    /**
     * Carrega os parâmetros enviados pelo e-SUS APS PEC e preenche
     * automaticamente o CPF do profissional.
     *
     * @returns {void}
     */
    carregarParametrosPec() {
      const parametrosUrl = new URLSearchParams(window.location.search)

      this.identificadorPublico = String(
        this.$route.params.identificador_publico || ''
      ).trim()

      this.cpf = String(
        this.$route.query.documentoProfissional ||
          parametrosUrl.get('documentoProfissional') ||
          ''
      )
        .replace(/\D/g, '')
        .trim()

      this.pecTimestamp = String(
        this.$route.query.pec_timestamp ||
          parametrosUrl.get('pec_timestamp') ||
          ''
      ).trim()

      this.pecSign = String(
        this.$route.query.pec_sign || parametrosUrl.get('pec_sign') || ''
      ).trim()

      this.cnes = String(
        this.$route.query.CNES || parametrosUrl.get('CNES') || ''
      )
        .replace(/\D/g, '')
        .trim()
    },

    /**
     * Valida a integração e verifica se o profissional já possui
     * usuário no e-SUS Feedback.
     *
     * @returns {Promise<void>}
     */
    async autenticarViaPec() {
      if (
        !this.identificadorPublico ||
        !this.cpf ||
        !this.pecTimestamp ||
        !this.pecSign ||
        !this.cnes
      ) {
        this.exibirErro(
          'Os dados de integração enviados pelo PEC estão incompletos.'
        )

        return
      }

      this.status = 'loading'
      this.loadingBtn = true
      this.verificandoUsuario = true
      this.mensagemErro = ''

      try {
        const { data } = await this.$apiPublic.post(
          `/pec/${this.identificadorPublico}/login`,
          {
            documentoProfissional: this.cpf.replace(/\D/g, ''),
            pec_timestamp: this.pecTimestamp,
            pec_sign: this.pecSign,
            cnes: this.cnes,
          }
        )

        const usuarioEncontrado =
          data.usuario_encontrado === true && Boolean(data.token)

        if (!usuarioEncontrado) {
          await this.tratarUsuarioNaoEncontrado()
          return
        }

        await this.tratarUsuarioEncontrado(data)
      } catch (error) {
        console.error('Erro ao autenticar pelo PEC:', error)

        const mensagem =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          'Não foi possível autenticar o acesso pelo PEC.'

        this.exibirErro(mensagem)
      } finally {
        this.loadingBtn = false
        this.verificandoUsuario = false
      }
    },

    /**
     * Inicia o fluxo autenticado quando o profissional já possui
     * usuário no e-SUS Feedback.
     *
     * @param {Object} dadosAutenticacao
     * @returns {Promise<void>}
     */
    async tratarUsuarioEncontrado(dadosAutenticacao) {
      const token = dadosAutenticacao.token

      if (!token) {
        throw new Error('Token de acesso não retornado pela integração.')
      }

      await this.prepararSessaoAutenticada(token)
    },

    /**
     * Trata temporariamente o caso em que o profissional ainda não
     * possui usuário no sistema.
     *
     * @returns {Promise<void>}
     */
    async tratarUsuarioNaoEncontrado() {
      this.status = 'usuario-nao-encontrado'
    },

    /**
     * Salva o token, carrega os dados do usuário e prepara a rota
     * de destino sem realizar o redirecionamento.
     *
     * @param {string} token
     * @returns {Promise<void>}
     */
    async prepararSessaoAutenticada(token) {
      this.$store.commit('setOrigemLogin', 'pec')
      this.$store.commit('updateAccessToken', token)

      const response = await this.$api.post('/app/auth/token')
      const usuario = response.data

      if (usuario.permissoes === false) {
        this.exibirErro(
          'Usuário sem permissões para acessar este município. Entre em contato com o suporte.'
        )

        return
      }

      await this.carregarDadosMunicipio(usuario)

      this.salvarDadosUsuario(usuario)

      localStorage.removeItem('aptoAvaliacaoNps')

      this.usuarioAutenticado = usuario

      this.rotaDestino = await this.obterRotaDestino(usuario)

      /*
       * Quando o login foi aberto em uma nova aba, não mostra novamente
       * a etapa de escolha de visualização.
       */
      if (this.acessoEmNovaAba) {
        await this.$router.replace(this.rotaDestino)
        return
      }

      this.status = 'escolha-visualizacao'
    },

    /**
     * Carrega os dados necessários do município após o login.
     *
     * @param {Object} usuario
     * @returns {Promise<void>}
     */
    async carregarDadosMunicipio(usuario) {
      const codIbge = usuario.cod_ibge

      if (!codIbge) {
        throw new Error(
          'O município do usuário não foi retornado pela autenticação.'
        )
      }

      await this.carregarUltimaAtualizacao(codIbge)

      const [equipes, microareas, regrasIndicadores, ultimosRegistros] =
        await Promise.all([
          Municipio.getEquipesPorMunicipio(codIbge),
          Municipio.getMicroAreasPorMunicipio(codIbge),
          Municipio.getRegrasIndicadoresPorMunicipio(codIbge),
          Municipio.ultimosRegistrosTabelasSincronizadas(codIbge),
        ])

      if (equipes) {
        this.$store.commit('setEquipesV2', equipes)
      }

      if (microareas) {
        this.$store.commit('setMicroAreas', microareas)
      }

      if (regrasIndicadores) {
        this.$store.commit('setRegrasIndicadoresAps', regrasIndicadores)
      }

      if (ultimosRegistros) {
        this.$store.commit(
          'setUltimosRegistrosTabelasSincronizadas',
          ultimosRegistros
        )
      }
    },

    /**
     * Carrega a última atualização dos dados do município.
     *
     * @param {string|number} codIbge
     * @returns {Promise<void>}
     */
    async carregarUltimaAtualizacao(codIbge) {
      if (this.$store.state.ultimaAtualizacao !== null) {
        return
      }

      const ultimaAtualizacao = await Municipio.getUltimaAtualizacao(codIbge)

      if (!ultimaAtualizacao) {
        return
      }

      if (ultimaAtualizacao.data_sincronizacao) {
        this.$store.commit(
          'setUltimaAtualizacao',
          ultimaAtualizacao.data_sincronizacao.split('-').reverse().join('/')
        )
      }

      if (ultimaAtualizacao.data_sincronizacao_c) {
        this.$store.commit('setSincronizadorC', {
          ultimaAtualizacao: ultimaAtualizacao.data_sincronizacao_c
            .split('-')
            .reverse()
            .join('/'),
          qtdDiasUltimaAtualizacao: ultimaAtualizacao.qtd_dias_c,
        })
      }
    },

    /**
     * Salva os dados do usuário e do município na store.
     *
     * @param {Object} usuario
     * @returns {void}
     */
    salvarDadosUsuario(usuario) {
      const infoMunicipio = this.montarInfoMunicipio(
        usuario.infoMunicipio || {}
      )

      const cidade = [infoMunicipio.no_municipio, infoMunicipio.no_uf]
        .filter(Boolean)
        .join(' - ')

      this.$store.commit('setCidade', cidade)
      this.$store.commit('setInfoMunicipio', infoMunicipio)
      this.$store.commit('setCodIbge', usuario.cod_ibge)
      this.$store.commit('setIdFuncao', usuario.id_funcao)
      this.$store.commit('setFuncao', usuario.funcao)
      this.$store.commit('setUnidadeSaude', usuario.unidade_saude)
      this.$store.commit('setId', usuario.id)
      this.$store.commit('setUsername', usuario.nome)
      this.$store.commit('setCoDimProf', usuario.co_dim_prof)

      this.$store.commit(
        'setCosDimProf',
        this.converterCosDimProf(usuario.cos_dim_prof)
      )

      this.$store.commit('setPermissoes', usuario.permissoes)
      this.$store.commit('setAjudaHierarchy', usuario.ajudaHierarchy)
      this.$store.commit(
        'setUltimaAtualizacaoCadastro',
        usuario.ultima_atualizacao_cadastro
      )
      this.$store.commit('setPdf', usuario.pdf)
      this.$store.commit('setNpsEfb', usuario.nps_efb)
      this.$store.commit('setFotoPerfil', usuario.foto_perfil)
    },

    /**
     * Monta as configurações visuais do município.
     *
     * @param {Object} municipio
     * @returns {Object}
     */
    montarInfoMunicipio(municipio) {
      const infoMunicipio = {
        exibe_logoefb: municipio.exibe_logoefb ?? '',
        exibe_whatsapp: municipio.exibe_whatsapp ?? '',
        logotipo: '',
        brasao: '',
        parceiro: municipio.parceiro ?? '',
        no_uf: municipio.no_uf ?? '',
        no_municipio: municipio.no_municipio ?? '',
      }

      if (infoMunicipio.exibe_logoefb == '1') {
        infoMunicipio.logotipo = require('@/assets/images/logo.png')
      } else if (municipio.logotipo) {
        infoMunicipio.logotipo =
          this.$api.defaults.baseURL +
          '/uploads/logotipos/' +
          municipio.logotipo
      }

      if (municipio.brasao) {
        infoMunicipio.brasao = '/api/uploads/brasao/' + municipio.brasao
      }

      return infoMunicipio
    },

    /**
     * Converte os códigos de profissionais retornados pela API.
     *
     * @param {string|Array|null} cosDimProf
     * @returns {Array|null}
     */
    converterCosDimProf(cosDimProf) {
      if (!cosDimProf) {
        return null
      }

      if (Array.isArray(cosDimProf)) {
        return cosDimProf
      }

      try {
        return JSON.parse(cosDimProf)
      } catch (error) {
        console.error('Não foi possível converter cos_dim_prof:', error)

        return null
      }
    },

    /**
     * Aplica as regras de acesso e retorna a rota de destino.
     *
     * @param {Object} usuario
     * @returns {Promise<string>}
     */
    async obterRotaDestino(usuario) {
      const idFuncao = Number(usuario.id_funcao)

      const precisaAtualizarCadastro = this.usuarioPrecisaAtualizarCadastro()

      this.$store.commit('setRequiredPasswordUpdate', precisaAtualizarCadastro)

      if (precisaAtualizarCadastro) {
        return '/atualizacao-cadastro'
      }

      const funcoesAdministrativas = [1, 2, 7, 9, 10, 11, 12, 13]

      if (funcoesAdministrativas.includes(idFuncao)) {
        return '/dashboard'
      }

      const profissionalValido = await this.validarProfissionalSaude(usuario)

      if (!profissionalValido) {
        return '/acesso-negado'
      }

      this.salvarDadosProfissional(usuario)

      return this.obterRotaProfissional(usuario)
    },

    /**
     * Retorna a rota do profissional conforme sua função e lotação.
     *
     * @param {Object} usuario
     * @returns {string}
     */
    obterRotaProfissional(usuario) {
      const idFuncao = Number(usuario.id_funcao)

      const funcoesComEscolhaDeLotacao = [4, 5, 8, 14, 15]

      if (!funcoesComEscolhaDeLotacao.includes(idFuncao)) {
        return '/dashboard'
      }

      const funcaoPodeIrDiretoParaDashboard =
        [5, 8].includes(idFuncao) && !this.$store.state.nu_ine

      if (funcaoPodeIrDiretoParaDashboard) {
        return '/dashboard'
      }

      return `/lotacoes/${usuario.cod_ibge}/${this.cpf}`
    },

    /**
     * Verifica se o CPF está associado a um profissional de saúde.
     *
     * @param {Object} usuario
     * @returns {Promise<boolean>}
     */
    async validarProfissionalSaude(usuario) {
      const response = await this.$api.post('/app/profissional-saude', {
        co_ibge: usuario.cod_ibge,
        cpf: this.cpf.replace(/\D/g, ''),
      })

      return response.data !== false
    },

    /**
     * Armazena os dados profissionais necessários para acessar
     * os módulos internos.
     *
     * No fluxo PEC, a microárea sempre vem do backend.
     *
     * @param {Object} usuario
     * @returns {void}
     */
    salvarDadosProfissional(usuario) {
      this.$store.commit('setNuCns', usuario.nu_cns)
      this.$store.commit('setNuIne', usuario.nu_ine)
      this.$store.commit('setNuIneVinculada', usuario.nu_ine_vinculada)
      this.$store.commit('setNuCnes', usuario.nu_cnes)
      this.$store.commit('setUnidadeSaude', usuario.unidade_saude)
      this.$store.commit('setMicroArea', usuario.micro_area)
    },

    /**
     * Verifica se o usuário precisa atualizar os dados cadastrais.
     *
     * @returns {boolean}
     */
    usuarioPrecisaAtualizarCadastro() {
      const ultimaAtualizacao = this.$store.state.ultimaAtualizacaoCadastro

      if (!ultimaAtualizacao) {
        return true
      }

      const dataComparacao = ultimaAtualizacao
        .split(' ')[0]
        .split('-')
        .reverse()
        .join('/')

      return this.diferencaMaiorQue6Meses(dataComparacao)
    },

    /**
     * Verifica se a data informada possui diferença superior
     * a seis meses em relação à data atual.
     *
     * @param {string} dataComparacao
     * @returns {boolean}
     */
    diferencaMaiorQue6Meses(dataComparacao) {
      if (!dataComparacao) {
        return true
      }

      const partesData = dataComparacao.split('/')

      if (partesData.length !== 3) {
        return true
      }

      const dia = Number(partesData[0])
      const mes = Number(partesData[1])
      const ano = Number(partesData[2])

      const dataAtualizacao = new Date(ano, mes - 1, dia)

      if (Number.isNaN(dataAtualizacao.getTime())) {
        return true
      }

      const dataLimite = new Date(dataAtualizacao)
      dataLimite.setMonth(dataLimite.getMonth() + 6)

      return new Date() > dataLimite
    },

    /**
     * Cadastra o profissional que ainda não possui usuário no sistema.
     *
     * @returns {Promise<void>}
     */
    async cadastrarUsuarioPec() {
      const formularioValido = await this.$refs.observerCadastro.validate()

      if (!formularioValido) {
        return
      }

      if (!this.aceitouTermos) {
        this.$toast.error('É necessário aceitar os termos de uso.', 'Erro:', {
          position: 'topRight',
        })

        return
      }

      if (!this.recaptchaValidado || !this.recaptchaToken) {
        this.$toast.error('Realize a verificação do reCAPTCHA.', 'Erro:', {
          position: 'topRight',
        })

        return
      }

      this.loadingBtn = true
      this.mensagemErro = ''

      try {
        const { data } = await this.$apiPublic.post(
          `/pec/${this.identificadorPublico}/cadastro`,
          {
            documentoProfissional: this.cpf.replace(/\D/g, ''),
            email: this.email,
            data_nascimento: this.dataNascimento,
            aceitou_termos: true,
            pec_timestamp: this.pecTimestamp,
            pec_sign: this.pecSign,
            cnes: this.cnes,
          }
        )

        if (!data.token) {
          throw new Error(
            data.message ||
              'O cadastro foi realizado, mas o token não foi retornado.'
          )
        }

        this.tokenCadastro = data.token
        this.status = 'cadastro-realizado'
      } catch (error) {
        console.error('Erro ao cadastrar usuário pelo PEC:', error)

        const mensagem =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          'Não foi possível concluir o cadastro.'

        this.$toast.error(mensagem, 'Erro:', {
          position: 'topRight',
        })

        this.resetarRecaptcha()
      } finally {
        this.loadingBtn = false
      }
    },

    /**
     * Continua o acesso após o usuário consultar a senha enviada por e-mail.
     *
     * @returns {Promise<void>}
     */
    async continuarAposCadastro() {
      if (!this.tokenCadastro) {
        this.exibirErro(
          'O token do cadastro não está disponível. Tente realizar o acesso novamente.'
        )

        return
      }

      this.loadingBtn = true

      try {
        await this.processarLoginAutenticado(this.tokenCadastro)
      } catch (error) {
        console.error('Erro ao continuar após o cadastro:', error)

        const mensagem =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          'Não foi possível continuar o acesso.'

        this.$toast.error(mensagem, 'Erro:', {
          position: 'topRight',
        })
      } finally {
        this.loadingBtn = false
      }
    },

    /**
     * Exibe uma mensagem de erro.
     *
     * @param {string} mensagem
     * @returns {void}
     */
    exibirErro(mensagem) {
      this.status = 'error'
      this.mensagemErro = mensagem
    },

    /**
     * Aceita os termos de uso.
     *
     * @returns {void}
     */
    aceitarTermos() {
      this.aceitouTermos = true
      this.showModalTermos = false
    },

    /**
     * Fecha o modal e remove a aceitação dos termos.
     *
     * @returns {void}
     */
    fecharModalTermos() {
      this.showModalTermos = false
      this.aceitouTermos = false
    },

    /**
     * Armazena o token retornado pelo recaptcha.
     *
     * @param {string} token
     * @returns {void}
     */
    onVerifyRecaptcha(token) {
      this.recaptchaToken = token
      this.recaptchaValidado = Boolean(token)
    },

    /**
     * Limpa o recaptcha quando sua validação expira.
     *
     * @returns {void}
     */
    onExpiredRecaptcha() {
      this.recaptchaToken = ''
      this.recaptchaValidado = false
    },

    /**
     * Trata falhas no carregamento ou validação do recaptcha.
     *
     * @returns {void}
     */
    onErrorRecaptcha() {
      this.recaptchaToken = ''
      this.recaptchaValidado = false
    },

    /**
     * Limpa o estado atual do recaptcha.
     *
     * @returns {void}
     */
    resetarRecaptcha() {
      this.recaptchaToken = ''
      this.recaptchaValidado = false

      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#login-pec {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  padding: 20px;
  background-color: #f8f9fa;

  form {
    width: 100%;
  }

  .card-login {
    width: 400px;
    max-width: 100%;
    padding: 1.85rem;
    position: relative;
    margin: 50px auto;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 10px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

    .btn {
      width: 100%;
      height: 40px;
      margin-top: 10px;
      display: inline-block;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      text-transform: uppercase;
      background-color: #0fafd7;
      border-radius: 32px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.14),
        0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px rgba(0, 0, 0, 0.12);
    }
  }

  .card-icon {
    position: relative;
    top: 0;
    width: 120px;
    height: 120px;
    padding: 10px;
    text-align: center;
    background: #f9f9f9;
    border-radius: 50%;

    i {
      font-size: 50px;
      line-height: 100px;
      text-align: center;
    }
  }

  .card-title {
    margin-bottom: 15px;
    padding-bottom: 10px;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    border-bottom: 1px solid #f5f5f5;
  }

  .login-pec-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding: 20px 0;
    text-align: center;

    &__spinner {
      width: 3rem;
      height: 3rem;
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      font-size: 38px;
      border-radius: 50%;

      &--error {
        color: #dc3545;
        background-color: rgba(220, 53, 69, 0.1);
      }

      &--success {
        color: #28a745;
        background-color: rgba(40, 167, 69, 0.1);
      }
    }

    h5 {
      margin: 0;
      color: #343a40;
      font-weight: 600;
    }

    p {
      max-width: 340px;
      margin: 0;
      color: #6c757d;
      line-height: 1.5;
    }
  }

  .error {
    color: #dc3545;
  }

  .checkbox-termos {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    color: #495057;

    input {
      margin-right: 3px;
    }

    label {
      margin: 0;
    }
  }

  .btn-termos {
    width: auto !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    color: #007bff !important;
    font-size: inherit !important;
    font-weight: normal !important;
    text-transform: none !important;
    text-decoration: underline;
    background: transparent !important;
    border: 0;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .recaptcha-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    overflow: hidden;
  }

  @media (max-width: 400px) {
    .recaptcha-wrapper {
      transform: scale(0.86);
      transform-origin: center;
    }
  }

  .escolha-visualizacao {
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding-top: 20px;
  }

  .btn-visualizacao {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    width: 100%;
    min-height: 54px;
    padding: 12px 20px;
    color: #495057;
    font-size: 17px;
    font-weight: 700;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 32px;
    cursor: pointer;
    transition: all 0.2s ease;

    i {
      font-size: 21px;
    }

    &:hover {
      border-color: #0fafd7;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.65;
    }

    &--principal {
      color: #0fafd7;
      border-color: #0fafd7;
    }
  }
}
</style>
